// src/index.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import App from '@/core/App';
import AppProvider from '@/core/AppProvider';
import pwaService from '@/services/pwaService';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>
);

// Register service worker for PWA (offline support, push notifications, install prompt)
pwaService.register();
